export default __webpack_public_path__ + "static/media/f2.3c4feccd.jpg";